import React from 'react';
import { Select, Input, Button, Popover, Icon, Tooltip, DatePicker, Checkbox, Popconfirm, Switch, message } from 'antd';
import { Link } from 'react-router-dom';
import SERVER_URL from '../Global';

const { Option } = Select;

class HandleHr extends React.Component {
    constructor(props) {
        super(props);
        let collabContacts = []
        let collabAddresses = []
        let allUpdated = true
        let id = 0
        let disabledHrDetails = false

        if (this.props.addresses != null) {
            if (this.props.addresses.length > 0) {
                this.props.addresses.map((add, i) => {
                    let text = add.street + ", " + add.zipCode.value + ", " + add.city.name + " (" + add.city.province.initials + ")"
                    //collabContacts.push({ text: text, id: i, remove: true, contactId: '', propId: 6, contactCreated: false })
                    collabAddresses.push({ text: text, id: i, remove: true, contactId: '', propId: 6, contactCreated: false, selected: false, collabId: add.office.brHrRoleOfficies[0].hroId })
                    id = i
                })
                id = id + 1
            }
        }

        /*
        if (this.props.collabId != null && this.props.collabHrs == null) {
            disabledHrDetails = true
        }*/

        if (this.props.collabContacts != null) {
            this.props.collabContacts.map(con => {
                collabContacts.push({ text: con.contact.text, id: con.contact.contactId, remove: true, contactId: '', propId: con.contact.property_TrValue, contactCreated: false })
                id = id + 1
            })
        }

        let collabHrs = null
        let hrCreated = false
        let hrId = ''
        let hrTitle = null

        if (this.props.collabHrs != null) {
            collabHrs = this.props.collabHrs
            hrCreated = true
            hrId = this.props.collabHrs.hrId
            allUpdated = false
            hrTitle = this.props.collab.title
        }

        this.state = {
            user: this.props.user,
            hrCreated: hrCreated,
            roleStatus: this.props.roleStatus,
            position: this.props.i + 1,
            hrName: null,
            hrTitle: hrTitle,
            hrSurname: null,
            roleId: this.props.roleId,
            contactsHr: [0],
            properties: this.props.properties,
            officeId: this.props.officeId,
            roleId: this.props.roleId,
            hroidCreated: false,
            contactHrId: 0,
            startValue: null,
            endValue: null,
            endOpen: false,
            isHr: this.props.isHr,
            companies: [],
            collabId: this.props.collabId,
            basicHroid: this.props.basicHroid,
            shrinked: false,
            propId: 3,
            contactModified: false,
            hrNameValidation: true,
            hrContactText: '',
            hrId: hrId,
            emailContactAlert: false,
            contacts: [],
            hroId: '',
            hrDeleted: false,
            collabContacts: collabContacts,
            collabAddresses: collabAddresses,
            collabHrs: collabHrs,
            adInterim: false,
            isAllUpdated: allUpdated,
            uniqueId: this.props.handleId,
            expanded: false,
            hrss: [{ hrId: 0, fullName: "Add New HR" }],
            newHr: false,
            visible: false,
            hrSameName: [],
            mandatoryName: false,
            mandatorySurname: false,
            disabledHrDetails: disabledHrDetails,
            hrCounter: this.props.hrCounter,
            choosenOne: false,
            hrOrder: this.props.order,
            noDetailsHrCounter: this.props.noDetailsHrCounter,
            showAddress: false,
            saveButtonDisabled: false,
            contactValidator: true,
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.saveCombo = this.saveCombo.bind(this);
        this.handleSurnameChange = this.handleSurnameChange.bind(this);
        this.saveHr = this.saveHr.bind(this);
        this.handleContactText = this.handleContactText.bind(this);
        this.handleProp = this.handleProp.bind(this);
        this.expand = this.expand.bind(this);
        this.shrink = this.shrink.bind(this);
        this.addInput = this.addInput.bind(this);
        this.removeContact = this.removeContact.bind(this);
        this.deleteHr = this.deleteHr.bind(this);
        this.handleCollabContact = this.handleCollabContact.bind(this);
        this.handleCollabAddress = this.handleCollabAddress.bind(this);
        this.handleInterim = this.handleInterim.bind(this);
        this.saveContacts = this.saveContacts.bind(this);
        this.searchByFullname = this.searchByFullname.bind(this);
        this.handleHrSelection = this.handleHrSelection.bind(this);
        this.handleVisibleChange = this.handleVisibleChange.bind(this);
        this.choosehr = this.choosehr.bind(this);
        this.saveHrAnyway = this.saveHrAnyway.bind(this);
        this.hide = this.hide.bind(this);
        this.checkHrname = this.checkHrname.bind(this);
        this.onChangeSwitchHrDetails = this.onChangeSwitchHrDetails.bind(this); 

        if (this.state.properties.length < 1) {
            //proprietà
            fetch(
                `${SERVER_URL + 'api/translation/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "typeTip": "Property",
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ properties: res.data }, this.setState({ propLoad: false }));
                })
        }
    }

    handleNameChange(event) {
        this.setState({ hrName: event.target.value, isAllUpdated: false, mandatoryName: true });
        if (event.target.value.length === 0) {
            this.setState({ hrName: null, mandatoryName: false })
        }
    }

    handleSurnameChange(event) {
        this.setState({ hrSurname: event.target.value, isAllUpdated: false });

        if (event.target.value.length === 0) {
            this.setState({ hrSurname: null, mandatorySurname: false })
        }
    }

    choosehr(hr) {
        this.setState({ hrId: hr.hrId, hrName: hr.name, hrSurname: hr.surname, hrCreated: true, visible: false, choosenOne: true }, this.saveCombo(hr.hrId, this.state.roleId))                
        this.sendStateHrCreated(true)
    }

    searchByFullname(value) {
        this.setState({ hrName: value, isAllUpdated: false, loading: true });

        if (value.length === 0) {
            this.setState({ hrName: null })
        }

        if (value.length > 2 || value.length == 0)
            fetch(
                `${SERVER_URL + 'api/hr/list?lang=en'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "NameSurname": value,
                        "page": 1,
                        "pageSize": 25,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": "",
                            "order": -1
                        },
                        "Status": 1,
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        let hrss = res.data

                        hrss.push({ hrId: 0, fullName: "Add New HR" })

                        this.setState({ hrss: hrss, loading: false, maxPageSize: res.params.totalPages });
                    }
                })
    }

    handleHrSelection(value) {

        if (value == 0) {
            this.setState({ visible: true });
        } else {
            var index = this.state.hrss.findIndex(obj => obj.hrId == value)

            this.setState({ hrId: value, hrName: this.state.hrss[index].name, hrSurname: this.state.hrss[index].surname, hrCreated: true })
        }
    }

    handleTitleChange(event) {
        this.setState({ hrTitle: event.target.value, isAllUpdated: false });

        if (event.target.value.length === 0) {
            this.setState({ hrTitle: null })
        }
    }

    disabledStartDate = startValue => {
        const { endValue } = this.state;
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    };

    disabledEndDate = endValue => {
        const { startValue } = this.state;
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    };

    onChange = (field, value) => {
        this.setState({
            [field]: value,
            isAllUpdated: false
        });
    };

    onStartChange = value => {
        this.onChange('startValue', value);
    };

    onEndChange = value => {
        this.onChange('endValue', value);
    };

    handleStartOpenChange = open => {
        if (!open) {
            this.setState({ endOpen: true });
        }
    };

    handleEndOpenChange = open => {
        this.setState({ endOpen: open });
    };


    saveHr() {
        this.setState({ saveButtonDisabled: true })
        //se i dettagli hr sono aperti
        if (!this.state.disabledHrDetails) {
            //se è l'hr di una collab o i contatti della collab esistono
            if (this.state.collabHrs != null || this.state.collabContacts.length != 0) {
                //salva un hr di una collab
                if (!this.state.hroidCreated) {
                    if (this.state.hrName == null && this.state.collabHrs == null) {
                        //se non hai inserito un nome                        
                        fetch(
                            `${SERVER_URL + "api/brHrRoleOffice"}`, {
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${this.state.user}`
                                },
                                body: JSON.stringify({
                                    "officeId": this.state.officeId,
                                    "roleId": this.state.roleId,
                                    "hrId": null,
                                    "hroId": this.state.basicHroid,
                                    "WorkingForHROId": this.state.collabId,
                                    "Status": this.props.status,
                                    "StartDate": this.state.startValue,
                                    "EndDate": this.state.endValue,
                                    "isAdInterim": this.state.adInterim,
                                    "showAddressWorkingFor": this.state.showAddress
                                })
                            }).then(response => response.json())
                            .then(res => {
                                this.setState({ hroId: this.state.basicHroid, hrCreated: true }, this.saveContacts)
                                this.sendStateHrCreated()
                            })
                    } else if (this.state.collabHrs != null) {
                        this.saveCombo(this.state.hrId, this.state.roleId);
                        this.setState({ hrCreated: true }, this.sendStateHrCreated)
                    } else {
                        //se non hai scritto un nome
                        let uniquename = this.state.hrName + " " + this.state.hrSurname
                        fetch(
                            `${SERVER_URL + 'api/hr/list?lang=en'}`, {
                                method: 'POST',
                                headers: {
                                    'Authorization': `Bearer ${this.state.user}`,
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    "uniquename": uniquename,
                                    "page": 1,
                                    "pageSize": 15,
                                    "Status": 1
                                })
                            }
                        ).then(response => response.json())
                            .then(res => {
                                if (res.data != null) {
                                    this.setState({ saveButtonDisabled: false, hrSameName: res.data, visible: true })
                                } else {
                                    fetch(
                                        `${SERVER_URL + "api/hr"}`, {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Authorization': `Bearer ${this.state.user}`
                                            },
                                            body: JSON.stringify({
                                                'name': this.state.hrName,
                                                'surname': this.state.hrSurname,
                                                "Status": this.props.status
                                            })
                                        }
                                    ).then(response => response.json())
                                        .then(res => {
                                            this.setState({ saveButtonDisabled: false, hrCreated: true, loading: false, hrDeleted: false, hrId: res.data, expanded: false, contactModified: false, hrNumber: this.state.hrNumber + 1, isAllUpdated: true }, this.saveCombo(res.data, this.state.roleId));
                                            this.sendStateHrCreated()
                                        })
                                }
                            }
                        )}
                }
                //se è già stato salvato l'hroid ed è una collaborazione
                else {
                    fetch(
                        `${SERVER_URL + "api/brHrRoleOffice"}`, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${this.state.user}`
                            },
                            body: JSON.stringify({
                                "officeId": this.state.officeId,
                                "roleId": this.state.roleId,
                                "hrId": this.state.hrId,
                                "WorkingForHROId": this.state.collabId,
                                "hroId": this.state.hroId,
                                "Status": this.props.status,
                                "StartDate": this.state.startValue,
                                "EndDate": this.state.endValue,
                                "ShowAddressWorkingFor": this.state.showAddress
                            })
                        }
                    ).then(
                        this.setState({ saveButtonDisabled: false, expanded: false, hrCreated: true, loading: false, hrDeleted: false, contactModified: false, hrNumber: this.state.hrNumber + 1, isAllUpdated: true }, this.saveContacts),
                        this.sendStateHrCreated()
                    )
                }
            } else {
                //se i contatti della collab non ci sono
                if (!this.state.hrCreated && this.state.roleStatus) {
                    //se l'hr non è stato creato (rolestatus è sempre true se sei qua)
                    this.setState({ loading: true })
                    if (this.state.hrName == null) {
                        //se non hai scritto un nome
                        this.setState({ saveButtonDisabled: false, isAllUpdated: true, expanded: false, contactModified: false, hroidCreated: true, loading: false });
                        if (this.state.hroidCreated) {
                            //se l'hroid è stato creato
                            fetch(
                                `${SERVER_URL + "api/brHrRoleOffice"}`, {
                                    method: 'PUT',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${this.state.user}`
                                    },
                                    body: JSON.stringify({
                                        "officeId": this.state.officeId,
                                        "roleId": this.state.roleId,
                                        "hroId": this.state.hroId,
                                        "WorkingForHROId": this.state.collabId,
                                        "Status": this.props.status,
                                        "StartDate": this.state.startValue,
                                        "EndDate": this.state.endValue,
                                        "ShowAddressWorkingFor": this.state.showAddress
                                    })
                                }
                            ).then(response => response.json())
                                .then(res => {
                                    if (res.data != 0) {
                                        this.saveContacts
                                    }
                                }
                            )
                        }
                        else {
                            //se l'hroid non è stato creato
                            fetch(
                                `${SERVER_URL + "api/brHrRoleOffice"}`, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${this.state.user}`
                                    },
                                    body: JSON.stringify({
                                        "officeId": this.state.officeId,
                                        "roleId": this.state.roleId,
                                        "WorkingForHROId": this.state.collabId,
                                        "Status": this.props.status,
                                        "StartDate": this.state.startValue,
                                        "EndDate": this.state.endValue,
                                        "ShowAddressWorkingFor": this.state.showAddress,
                                    })
                                }
                            ).then(response => response.json())
                                .then(res => {
                                    if (res.data != 0) {
                                        this.setState({ saveButtonDisabled: false, hroId: res.data, hroidCreated: true, loading: false, hrCreated: true, isAllUpdated: true }, this.saveContacts);
                                        this.sendStateHrCreated();
                                    }
                                    else {
                                        fetch(
                                            `${SERVER_URL + 'api/brhrroleoffice/list'}`, {
                                                method: 'POST',
                                                headers: {
                                                    'Authorization': `Bearer ${this.state.user}`,
                                                    'Content-Type': 'application/json'
                                                },
                                                body: JSON.stringify({
                                                    "officeId": this.state.officeId,
                                                    "roleId": this.state.roleId,
                                                    'hrid': -1,
                                                    "page": 1,
                                                    "totalPages": 0,
                                                    "totalItems": 0,
                                                    "pageSize": 1,
                                                    "pageSizeOptions": null,
                                                    "ordering": {
                                                        "orderPropertyName": this.state.orderBy,
                                                        "order": this.state.order
                                                    },
                                                    "firstItemNumber": 0,
                                                    "lastItemNumber": 0,
                                                    "entityId": 0
                                                })
                                            }
                                        ).then(response => response.json())
                                            .then(res => {
                                                this.setState({ saveButtonDisabled: false, hroId: res.data[0].hroId, hroidCreated: true, loading: false, hrCreated: true, isAllUpdated: true }, this.saveContacts);
                                                this.sendStateHrCreated()
                                            })
                                    }
                                }
                                )
                        }
                    }
                    else {
                        //se hai scritto un nome
                        let uniquename = this.state.hrName + " " + this.state.hrSurname

                        fetch(
                            `${SERVER_URL + 'api/hr/list?lang=en'}`, {
                                method: 'POST',
                                headers: {
                                    'Authorization': `Bearer ${this.state.user}`,
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    "uniquename": uniquename,
                                    "page": 1,
                                    "pageSize": 15,
                                    "Status": 1
                                })
                            }
                        ).then(response => response.json())
                            .then(res => {
                                if (res.data != null) {
                                    this.setState({ saveButtonDisabled: false, hrSameName: res.data, visible: true })
                                }
                                else {
                                    fetch(
                                        `${SERVER_URL + "api/hr"}`, {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Authorization': `Bearer ${this.state.user}`
                                            },
                                            body: JSON.stringify({
                                                'name': this.state.hrName,
                                                'surname': this.state.hrSurname,
                                                "Status": this.props.status
                                            })
                                        }
                                    ).then(response => response.json())
                                        .then(res => {
                                            this.setState({ saveButtonDisabled: false, hrCreated: true, loading: false, hrDeleted: false, hrId: res.data, expanded: false, contactModified: false, hrNumber: this.state.hrNumber + 1, isAllUpdated: true }, this.saveCombo(res.data, this.state.roleId));
                                            this.sendStateHrCreated()
                                        })
                                }
                            })
                    }
                }
                else {
                    fetch(`${SERVER_URL + 'api/hr'}`, {
                        method: 'PUT',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        },
                        body: JSON.stringify({
                            'name': this.state.hrName,
                            'surname': this.state.hrSurname,
                            'hrid': `${this.state.hrId}`,
                            "Status": this.props.status
                        })
                    })
                    this.setState({ saveButtonDisabled: false, expanded: false, hrCreated: true, loading: false, hrDeleted: false, contactModified: false, hrNumber: this.state.hrNumber + 1, isAllUpdated: true })
                    this.saveCombo(this.state.hrId, this.state.roleId)
                    this.sendStateHrCreated()
                }
            }
            //se non ci sono details
        } else {
            //se non ci sono dettagli dell'hr
            if (!this.state.hrCreated) {
                fetch(
                    `${SERVER_URL + "api/brHrRoleOffice"}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        },
                        body: JSON.stringify({
                            "officeId": this.state.officeId,
                            "roleId": this.state.roleId,
                            "WorkingForHROId": this.state.collabId,
                            "Status": this.props.status,
                            "StartDate": this.state.startValue,
                            "EndDate": this.state.endValue,
                            "ShowAddressWorkingFor": this.state.showAddress
                        })
                    }
                ).then(response => response.json())
                    .then(res => {
                        if (res.data != 0) {
                            this.setState({ saveButtonDisabled: false, hroId: res.data, hroidCreated: true, loading: false, hrCreated: true, isAllUpdated: true });
                            this.sendStateHrCreated()
                        }
                        else {
                            fetch(
                                `${SERVER_URL + 'api/brhrroleoffice/list'}`, {
                                    method: 'POST',
                                    headers: {
                                        'Authorization': `Bearer ${this.state.user}`,
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        "officeId": this.state.officeId,
                                        "roleId": this.state.roleId,
                                        'hrid': -1,
                                        "page": 1,
                                        "totalPages": 0,
                                        "totalItems": 0,
                                        "pageSize": 1,
                                        "pageSizeOptions": null,
                                        "ordering": {
                                            "orderPropertyName": this.state.orderBy,
                                            "order": this.state.order
                                        },
                                        "firstItemNumber": 0,
                                        "lastItemNumber": 0,
                                        "entityId": 0
                                    })
                                }
                            ).then(response => response.json())
                                .then(res => {
                                    this.setState({ saveButtonDisabled: false, hrCreated: true, loading: false, hroId: res.data[0].hroId, hrId: null, hroidCreated: true, hrNumber: this.state.hrNumber + 1, isAllUpdated: true, contactModified: false });
                                    this.sendStateHrCreated()
                                    this.saveCombo(this.state.hrId, this.state.roleId)
                                })
                        }
                    })
            } else {
                this.setState({ saveButtonDisabled: false, isAllUpdated: true, loading: false, contactModified: false })
                this.saveCombo(null, this.state.roleId)
            }
        }
    }

    //checkForDouble
    checkHrname() {
        let uniquename = this.state.hrName + " " + this.state.hrSurname;

        fetch(
            `${SERVER_URL + 'api/hr/list?lang=en'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "uniquename": uniquename,
                    "page": 1,
                    "pageSize": 15,
                    "Status": 1
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ hrSameName: res.data, visible: true })
                }
                this.setState({ mandatorySurname: true })
            })
    }

    saveHrAnyway() {
        fetch(
            `${SERVER_URL + "api/hr"}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    'name': this.state.hrName,
                    'surname': this.state.hrSurname,
                    "Status": this.props.status
                })
            }
        ).then(response => response.json())
            .then(res => {
                this.setState({ hrCreated: true, loading: false, hrDeleted: false, hrId: res.data, expanded: false, contactModified: false, hrNumber: this.state.hrNumber + 1, isAllUpdated: true }, this.saveCombo(res.data, this.state.roleId));
                this.sendStateHrCreated()
            })
    }

    saveCombo(HrId, roleId) {
        if (this.state.disabledHrDetails && this.state.collabHrs != null) {
            this.setState({ hroId: this.state.basicHroid, hroidCreated: true, loading: false, saveButtonDisabled: false }, this.saveContacts);
        }
        else if (!this.state.hroidCreated) {
            this.setState({ loading: true });
            fetch(
                `${SERVER_URL + "api/brHrRoleOffice"}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        "officeId": this.state.officeId,
                        "roleId": roleId,
                        "hrId": HrId,
                        "WorkingForHROId": this.state.collabId,
                        "Status": this.props.status,
                        "StartDate": this.state.startValue,
                        "EndDate": this.state.endValue,
                        "isAdInterim": this.state.adInterim,
                        "Sort": this.state.hrOrder,
                        'title': this.state.hrTitle,
                        "ShowAddressWorkingFor": this.state.showAddress
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.ok) {
                        this.setState({ hroId: res.data, hroidCreated: true, loading: false, saveButtonDisabled: false }, this.saveContacts);
                    } else {
                        this.setState({ hroId: this.state.basicHroid, hroidCreated: true, loading: false, saveButtonDisabled: false }, this.saveContacts);
                    }
                }
            )
        } else {
            fetch(
                `${SERVER_URL + "api/brHrRoleOffice"}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    "officeId": this.state.officeId,
                    "roleId": roleId,
                    "hrId": HrId,
                    "hroId": this.state.hroId,
                    "WorkingForHROId": this.state.collabId,
                    "Status": this.props.status,
                    "StartDate": this.state.startValue,
                    "EndDate": this.state.endValue,
                    "isAdInterim": this.state.adInterim,
                    "Sort": this.state.hrOrder,
                    'title': this.state.hrTitle,
                    "ShowAddressWorkingFor": this.state.showAddress
                })
            }).then(this.saveContacts)
        }
    }

    saveContacts() {
        //salva contatti
        this.state.contacts.map((con, i) => {
            if (!con.remove && !con.contactCreated) {
                fetch(
                    `${SERVER_URL + "api/contact"}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        },
                        body: JSON.stringify({
                            'text': `${con.text}`,
                            'Property_TrValue': `${con.propId}`,
                        })
                    }
                ).then(response => response.json())
                    .then(res => {
                        this.state.contacts[i].contactId = res.data
                        this.state.contacts[i].contactCreated = true
                        //colleghiamo il contatto alla role office
                        fetch(
                            `${SERVER_URL + "api/brHrRoleOfficeContact"}`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${this.state.user}`
                            },
                            body: JSON.stringify({
                                'hroId': this.state.hroId,
                                'contactId': res.data,
                                'isCollaboration': false,
                                "Status": 1,
                                'sort': con.id
                            })
                        })
                        // fine fetch
                    })
            } else if (!con.remove && con.contactId !== '') {
                fetch(`${SERVER_URL + 'api/contact'}`, {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'text': `${con.text}`,
                        'Property_TrValue': `${con.propId}`,
                        'contactid': con.contactId
                    })
                }).then(response => response.json())
                    .then(res => {
                        fetch(
                            `${SERVER_URL + "api/brHrRoleOfficeContact/"}`, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${this.state.user}`
                            },
                            body: JSON.stringify({
                                'hroId': this.state.hroId,
                                'contactId': con.contactId,
                                'isCollaboration': false,
                                "Status": 1,
                                'sort': con.id
                            })
                        })
                    })
            } else if (con.remove && con.contactCreated) {
                //scolleghiamo il contatto dalla role office
                fetch(
                    `${SERVER_URL + "api/brHrRoleOfficeContact/" + this.state.hroId + "/" + con.contactId}`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    }
                }).then(response => response.json())
                    .then(res => {
                        this.state.contacts[i].contactCreated = false

                        if (!con.isCollaboration) {
                            fetch(`${SERVER_URL + `api/contact/hard/${con.contactId}`}`, {
                                method: 'DELETE',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${this.state.user}`
                                }
                            }).then(response => response.json())
                                .then(res => {
                                    if (!res.ok) {
                                        message.warning("The contact is shared by other companies, it has not been deleted")
                                    }
                                })
                        }
                    })
                //fine fetch
            }
        })

        //collab contatti
        this.state.collabContacts.map((con, i) => {
            if (!con.remove && !con.contactCreated) {
                //colleghiamo il contatto alla role office
                fetch(
                    `${SERVER_URL + "api/brHrRoleOfficeContact"}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'hroId': this.state.hroId,
                        'contactId': con.id,
                        'isCollaboration': true,
                        "Status": 1
                    })
                }).then(
                    this.state.collabContacts[i].contactCreated = true
                )
                // fine fetch
            }
            else if (con.remove && con.contactCreated) {
            fetch(`${SERVER_URL + `api/contact/hard/${con.contactId}`}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                }
            }).then(
                this.state.collabContacts[i].contactCreated = false,
                //scolleghiamo il contatto dalla role office
                fetch(
                    `${SERVER_URL + "api/brHrRoleOfficeContact/" + this.state.hroId + "/" + con.contactId}`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    }
                    })
                    // fine fetch
                )
            }
        })
        this.setState({ isAllUpdated: true, contactModified: false })
    }

    componentDidUpdate(prevProps) {
        if (this.props.order !== prevProps.order && this.state.hroidCreated) {
            this.newOrder(this.props.order);
            this.setState({ hrOrder: this.props.order })
        }
        if (this.props.noDetailsHrCounter !== prevProps.noDetailsHrCounter) {
            this.setState({ noDetailsHrCounter: this.props.noDetailsHrCounter })
        }
    }

    newOrder(order) {
        fetch(
            `${SERVER_URL + "api/brHrRoleOffice"}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    "hroid": this.state.hroId,
                    "officeId": this.state.officeId,
                    "roleId": this.state.roleId,
                    "hrId": this.state.hrId,
                    "WorkingForHROId": this.state.collabId,
                    "Status": this.props.status,
                    "StartDate": this.state.startValue,
                    "EndDate": this.state.endValue,
                    "Sort": order,
                    'title': this.state.hrTitle,
                    "ShowAddressWorkingFor": this.state.showAddress
                })
            }
        )
    }

    deleteHr() {
        if (this.state.hrCreated && this.state.collabHrs === null && !this.state.disabledHrDetails) {
            fetch(
                `${SERVER_URL + 'api/brhrroleoffice/hard/' + this.state.hroId}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    }
                }
            )
            this.setState({ hrCreated: false, hrDeleted: true })
            this.sendDataToHandleRole(this.props.i)
            this.sendCounterToHandleRole()
        }
        else if (this.state.hrCreated && this.state.collabHrs !== null && this.state.hroidCreated && !this.state.disabledHrDetails) {

            fetch(
                `${SERVER_URL + 'api/brhrroleoffice/hard' + this.state.hroId}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    }
                }
            )
            this.setState({ hrCreated: false, hrDeleted: true })
        } else if (this.state.hroidCreated && this.state.disabledHrDetails) {

            fetch(
                `${SERVER_URL + 'api/brhrroleoffice/hard' + this.state.hroId}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    }
                }
            )
            this.setState({ hrCreated: false, hrDeleted: true })
        }
        else {
            this.setState({ hrCreated: false, hrDeleted: true })
            this.sendDataToHandleRole(this.props.i)
            this.sendCounterToHandleRole()
        }
    }

    //inizio contatti
    handleProp(value, i) {
        let emailValidator = true
        let urlValidator = true
        if (!this.state.contacts.hasOwnProperty(i)) {
            this.state.contacts.push({ text: '', id: i, remove: false, contactId: '', propId: value, contactCreated: false })
        } else {
            this.state.contacts[i].propId = value
            if (this.state.contacts[i].text > 0) {
                if ((value == 5 || value == 23) && !this.state.contacts[i].text.includes('@')) {
                    document.getElementById("emailHasAtHr" + i + this.state.roleId + this.state.uniqueId).style.display = 'block'
                }
                else {
                    document.getElementById("emailHasAtHr" + i + this.state.roleId + this.state.uniqueId).style.display = 'none'
                    emailValidator = true
                }
            }
            if (value == 4 && !this.state.contacts[i].text.includes('http')) {
                document.getElementById("urlHasHttp" + i + this.state.roleId + this.state.uniqueId).style.display = 'block'
                urlValidator = false
            } else {
                document.getElementById("urlHasHttp" + i + this.state.roleId + this.state.uniqueId).style.display = 'none'
                urlValidator = true
            } 
        }
        let contactValidator = emailValidator && urlValidator ? true : false
        this.setState({ contactModified: true, contactValidator: contactValidator });
    }

    handleContactText(event, i) {
        var field = "contactText" + i
        if (event.target.value.length > 0) {
            this.setState({ [field]: event.target.value, contactModified: true });
        } else if (event.target.value.length === 0) {
            this.setState({ contactModified: false, [field]: null });
        }
    }

    addContact(i) {
        let emailValidator = true
        let urlValidator = true
        var field = "contactText" + i
        var text = this.state[field]

        if (!this.state.contacts.hasOwnProperty(i)) {
            this.state.contacts.push({ text: text, id: i, remove: false, contactId: '', propId: 3, contactCreated: false })
        } else {
            this.state.contacts[i].text = text
            if ((this.state.contacts[i].propId === 5 || this.state.contacts[i].propId === 23) && !text.includes('@')) {
                document.getElementById("emailHasAtHr" + i + this.state.roleId + this.state.uniqueId).style.display = 'block'
                emailValidator = false
            }
            else {
                document.getElementById("emailHasAtHr" + i + this.state.roleId + this.state.uniqueId).style.display = 'none'
                emailValidator = true
            }
            if (this.state.contacts[i].propId === 4 && !text.includes('http')) {
                document.getElementById("urlHasHttp" + i + this.state.roleId + this.state.uniqueId).style.display = 'block'
                urlValidator = false
            }
            else {
                document.getElementById("urlHasHttp" + i + this.state.roleId + this.state.uniqueId).style.display = 'none'
                urlValidator = true
            }
        }
        let contactValidator = emailValidator && urlValidator ? true : false
        this.setState({ contactModified: true, contactValidator: contactValidator, saveButtonDisabled: false });
    }

    addInput(i) {
        if (i >= this.state.contactHrId) {
            var id = this.state.contactHrId + 1

            this.setState({ contactHrId: id })
            this.setState({ contactHrId: id })

            this.state.contactsHr.push(id)
        }
    }

    removeContact(i) {
        if (this.state.contacts.hasOwnProperty(i)) {
            this.state.contacts[i].remove = true
        }

        this.setState({ contactModified: true })

        document.getElementById("contactHr_" + this.state.roleId + "_" + this.state.hrId + "_" + i).remove()
    }

    handleCollabAddress(id, e) {
        let collab = this.state.collabAddresses
        let collabId = this.state.collabId
        let showAddress = true

        if (collab[id].collabId == this.state.collabId && this.state.showAddress) {
            showAddress = false
        } else {
            collabId = collab[id].collabId
            collab[id].selected = true
        }

        this.setState({ collabAddresses: collab, contactModified: true, collabId: collabId, showAddress: showAddress })
    }

    handleCollabContact(id, e) {
        let collab = this.state.collabContacts


        collab[id].remove = !e.target.checked

        this.setState({ collabContacts: collab, contactModified: true, saveButtonDisabled: false })
    }

    //fine contatti

    handleInterim(e) {
        if (e.target.checked) {
            this.setState({ adInterim: true })
        } else {
            this.setState({ adInterim: false })
        }
        this.setState({ isAllUpdated: false })
    }

    shrink() {
        this.setState({ shrinked: true })
    }

    expand() {
        this.setState({ shrinked: false })
    }

    sendDataToHandleRole = () => {
        this.props.showOrderButtons(false, this.props.i);
    }

    sendnoDetailsCounter = () => {
        if (!this.state.disabledHrDetails) {
            this.props.parentnoDetailsCounter(1)
        } else {
            this.props.parentnoDetailsCounter(0)
        }
    }

    sendCounterToHandleRole = () => {
        this.props.parentCounterDeletedHr(1);
    }

    sendStateHrCreated = (value) => {
        if (this.state.hrCreated == true || value == true) {
            this.props.callbackHrIsCreated(true);
        }
    }

    handleVisibleChange = visible => {
        this.setState({ visible });
    };

    hide = () => {
        this.setState({
            visible: false,
        });
    };

    onChangeSwitchHrDetails(value) {
        let valueOpposite = value ? false : true
        this.setState({ disabledHrDetails: valueOpposite, isAllUpdated: false })
        //invio al componente padre due dati: il primo per indicargli che nel componente c'è un HR senza details, il secondo per passargli la posizione di questo Hr senza detail
        this.sendnoDetailsCounter()
        this.sendOrder()
    }

    sendOrder = () => {
        let order = this.state.hrOrder - 1
        this.props.parentCallbackOrder(order);
    }

    render() {

        const selectBeforeProp = (i) => (
            <Select onChange={(value) => this.handleProp(value, i)} defaultValue="Telephone" style={{ width: 90 }}>
                {this.state.properties.map(prop => {
                    if (prop.value != 6) {
                        return <Option key={prop.text} value={prop.value}>{prop.text}</Option>
                    }
                })
                }
            </Select>
        );

        let checkGreen = this.state.isAllUpdated && !this.state.contactModified && !this.state.expanded ? true : false

        let allSavedBlock = <p>Everything is already Saved</p>

        let mandatoryNotMet = this.state.contactValidator ? <p> One or more Mandatory Fields are empty</p> : <p> One or more contact are not validated</p>

        let mandatoryName = this.state.collabHrs || this.state.collabContacts.length > 0 ? <Icon type="check-circle" /> : this.state.mandatoryName ? <Icon type="check-circle" /> : <Tooltip title="This field is mandatory"><Icon type="exclamation-circle" /></Tooltip>

        let mandatorySurname = this.state.collabHrs || this.state.collabContacts.length > 0 ? <Icon type="check-circle" /> : this.state.mandatorySurname ? <Icon type="check-circle" /> : this.state.hrSurname == null ? <Tooltip title="This field is mandatory"><Icon type="exclamation-circle" /></Tooltip> : <Tooltip title="Click out from this field to start checking for duplicates"><Icon type="exclamation-circle" /></Tooltip>

        let saveGuys = this.state.hrSameName.length > 0 ? <span onClick={this.saveHrAnyway} className="fakeLink">Save Anyway</span> : <span onClick={this.saveHr} className="fakeLink">Save</span>

        let newHrorOldHr =
            <div>
                <ul style={{ listStyle: 'none' }}>{this.state.hrSameName.map(hr =>
                    <li key={hr.hrId}>
                        <p className="fakeLink" onClick={() => this.choosehr(hr)} >{hr.fullName} - {
                            hr.brHrRoleOfficies.map(br => {
                                if (br.role != null) {
                                    if (br.office != null) {
                                        if (br.office.company != null) {
                                            return <span key={br.hroId}>{br.role.name} - {br.office.company.name}; </span>
                                        }
                                    }
                                }
                            })
                        }
                        </p>
                    </li>
                )}</ul>
                {saveGuys}
            </div>

        let fullName = <Link to={"/modifyhr?hrId=" + this.state.hrId}>{this.state.hrName + " " + this.state.hrSurname}</Link>

        let hrChosen = !this.state.disabledHrDetails ? !this.state.choosenOne ?
            <div className="nameSurnameBox">
                <Input autoComplete="new-password" className={"hrName contactText"} allowClear={true} placeholder="Name" value={this.state.hrName} onChange={this.handleNameChange} />
                {mandatoryName}
                <Popover
                    content={<a onClick={this.hide}>{newHrorOldHr}</a>}
                    title="Name already used"
                    trigger="click"
                    visible={this.state.visible}
                >
                    <Input autoComplete="new-password" className="hrSurname contactText" allowClear={true} placeholder="Surname" value={this.state.hrSurname} onBlur={this.checkHrname} onChange={this.handleSurnameChange} />
                    {mandatorySurname}
                </Popover>
            </div> :
            <div className="nameSurnameBox">
                <Tooltip placement="topLeft" title="This HR has been connected with other Roles">
                    <h4 style={{ marginTop: '15px' }}><Icon type="info-circle" /> Linked Hr Fullname:</h4>
                </Tooltip>
                <p style={{ margin: '0px 0px 0px 13px' }}>{fullName}</p>
            </div>
            : null

        const { startValue, endValue, endOpen } = this.state;

        let inputTitle = !this.state.disabledHrDetails ? <Input autoComplete="new-password" className="hrTitle" placeholder="Title" allowClear={true} onChange={this.handleTitleChange} /> : null
        let checkDisabled = <p>It is not possible to activate this switch for more than one HR in each role</p>
        let inputCheckBox = !this.state.disabledHrDetails ? <Checkbox style={{ marginLeft: '15px' }} onChange={(e) => this.handleInterim(e)}>Ad Interim</Checkbox> : null
        let switchNoDetails = this.state.noDetailsHrCounter == 0 ?
            <Switch style={{ marginTop: '22px', marginLeft: '15px' }} defaultChecked={true} onChange={this.onChangeSwitchHrDetails} /> :
            this.state.disabledHrDetails ?
                <Switch style={{ marginTop: '22px', marginLeft: '15px' }} disabled checked={false} onChange={this.onChangeSwitchHrDetails} /> :
                <Popover content={checkDisabled}><Switch disabled checked={true} style={{ marginTop: '22px', marginLeft: '15px' }} onChange={this.onChangeSwitchHrDetails} /></Popover> 

        let hrCollab = this.state.collabHrs !== null ?
            <div className="hrItemLeft" >
                <Tooltip placement="topLeft" title="Switch to create Role without Hr">
                    <h4><Icon type="info-circle" /> Hr Details:</h4>
                </Tooltip>

                <Input autoComplete="new-password" style={{ width: '100%' }} className="hrTitle" placeholder="Title" value={this.state.hrTitle} allowClear={true} onChange={this.handleTitleChange} />
                <Tooltip placement="topLeft" title="Collaboration's HR full name">
                    <h4><Icon type="info-circle" /> Hr full name:</h4>
                </Tooltip>
                <p className="hrCollabName">{this.state.collabHrs.name} {this.state.collabHrs.surname}</p>
            </div> :
            <div className="hrItemLeft" >
                <div style={{ width: '100%', display: 'inline-flex' }}>
                    <Tooltip placement="topLeft" title="Switch to creare Role without Hr">
                        <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Hr Details:</h4> 
                    </Tooltip>
                    {switchNoDetails}
                </div>
                {inputTitle}
                {inputCheckBox}
                {hrChosen}
            </div>

        let hrSave = checkGreen ?
            <Popover content={allSavedBlock}>
                <Button disabled className="saveButtonHrWizard" icon="save">Save Hr</Button>
            </Popover>
            : this.state.collabHrs || this.state.collabContacts.length > 0 ?
                <Button onClick={this.saveHr} disabled={this.state.saveButtonDisabled} className="saveButtonHrWizard" icon="save">Save Hr</Button>
                : this.state.disabledHrDetails ?
                    <Button onClick={this.saveHr} disabled={this.state.saveButtonDisabled} className="saveButtonHrWizard" icon="save">Save Hr</Button>
                    : this.state.mandatoryName && this.state.mandatorySurname && this.state.contactValidator ?
                        <Button onClick={this.saveHr} disabled={this.state.saveButtonDisabled} className="saveButtonHrWizard" icon="save">Save Hr</Button>
                        :   <Popover content={mandatoryNotMet}>
                                <Button disabled className="saveButtonHrWizard" icon="save">Save Hr</Button>
                            </Popover>
                            

        let datePicker = !this.state.disabledHrDetails ?
            <div style={{ display: 'inline-flex', width: 'calc(100% - 1px)', marginBottom: '1em' }}>

                <div className="hrItemLeftSecondRow" >
                    <Tooltip placement="topLeft" title="Select here the starting date">
                        <h4><Icon type="info-circle" /> Starting Date:</h4>
                    </Tooltip>

                    <DatePicker
                        disabled={this.state.disabledHrDetails}
                        disabledDate={this.disabledStartDate}
                        format="DD/MM/YYYY"
                        value={startValue}
                        className="startDatePicker"
                        placeholder="DD/MM/YYYY"
                        onChange={this.onStartChange}
                        onOpenChange={this.handleStartOpenChange}
                    />
                </div>

                <div className="hrItemRightSecondRow" >
                    <Tooltip placement="topLeft" title="Select here the ending date">
                        <h4><Icon type="info-circle" /> Ending Date:</h4>
                    </Tooltip>

                    <DatePicker
                        disabled={this.state.disabledHrDetails}
                        disabledDate={this.disabledEndDate}
                        format="DD/MM/YYYY"
                        value={endValue}
                        className="endDatePicker"
                        placeholder="DD/MM/YYYY"
                        onChange={this.onEndChange}
                        open={endOpen}
                        onOpenChange={this.handleEndOpenChange}
                    />
                </div>

            </div> : null

        let shrinkedOrNot = !this.state.shrinked ?
            <div>
                {datePicker}

                <Tooltip placement="topLeft" title="Add phone number, website, email, address, Fax, social media links">
                    <h4 style={{ marginTop: '1em' }}><Icon type="info-circle" /> Contacts:</h4>
                </Tooltip>

                {this.state.collabAddresses.map((con, i) => (
                    <div className="wizardHrContacts" key={i}>
                        <p style={{ marginBottom: '20px' }}>
                            <Checkbox
                                disabled={false}
                                onChange={(e) => this.handleCollabAddress(i, e)}
                                checked={this.state.collabAddresses[i].collabId == this.state.collabId && this.state.showAddress}
                            >
                                {con.text}
                            </Checkbox>
                        </p>
                    </div>
                ))}

                <hr />

                {this.state.collabContacts.map((con, i) => (
                    <div className="wizardHrContacts" key={i}>
                        <p style={{ marginBottom: '20px' }}>
                            <Checkbox
                                disabled={false}
                                onChange={(e) => this.handleCollabContact(i, e)}
                            >
                                {con.text}
                            </Checkbox>
                        </p>
                    </div>
                ))}

                {this.state.contactsHr.map(i =>
                    <div className="wizardHrContacts" id={"contactHr_" + this.state.roleId + "_" + this.state.hrId + "_" + i} key={i}>
                        <Input autoComplete="new-password" onPressEnter={() => this.addInput(i)} onBlur={() => this.addContact(i)} onChange={(e) => this.handleContactText(e, i)} className={"modified" + this.state.contactModified} style={{ width: 'calc(100% - 34px)', height: '100%' }} addonBefore={selectBeforeProp(i)} placeholder="Insert text" />
                        <Popconfirm title="Are you sure delete this contact?" okText="Yes" cancelText="No" onConfirm={() => this.removeContact(i)} ><Icon style={{ marginLeft: '14px', marginTop: '1px', cursor: 'pointer', top: '2px', position: 'relative' }} className={"anticon-save deleteDisplay" + this.state.contacts.hasOwnProperty(i)} type="close" /></Popconfirm>
                        <p className="emailHasAt" style={{ display: 'none' }} id={"emailHasAtHr" + i + this.state.roleId + this.state.uniqueId}> Warning! "@" is missing</p>
                        <p className="emailHasAt" style={{ display: 'none' }} id={"urlHasHttp" + i + this.state.roleId + this.state.uniqueId}> Warning! http:// or https:// are missing</p>
                    </div>
                )
                }

                <Button onClick={() => this.addInput(this.state.contactHrId)} className="createContactButton" icon="plus"></Button>

                <div className="buttonsSaveHr">
                    {hrSave}
                    <Button onClick={this.shrink} className="deleteButtonHrWizard" icon="shrink">Collapse</Button>
                    <Popconfirm placement="top" title="Are you sure you want to delete HR from this role?" onConfirm={this.deleteHr} okText="Yes" cancelText="No"><Button className="deleteButtonHrWizard"><Icon type="close" /> Delete Hr</Button></Popconfirm>
                </div>
            </div> :

            <div className={"buttonsSaveHrShrinked" + this.state.disabledHrDetails}>
                {hrSave}
                <Button onClick={this.expand} className="deleteButtonHrWizard" icon="arrows-alt">Expand</Button>
                <Popconfirm placement="top" title="Are you sure you want to delete HR from this role?" onConfirm={this.deleteHr} okText="Yes" cancelText="No"><Button className="deleteButtonHrWizard"><Icon type="close" /> Delete Hr</Button></Popconfirm>
            </div>

        let showHr = this.state.hrDeleted ? "" :
            <div style={{ order: this.state.position, width: '100%', listStyle: 'none' }} className="hrListBox">
                <div className={this.state.hrCreated + "" + this.state.hrDeleted + "hrCreated" + checkGreen}>
                    {hrCollab}
                    {shrinkedOrNot}
                </div>

            </div>

        return (
            <div>
                {showHr}
            </div>
        )
    }
}

export default HandleHr;


// WEBPACK FOOTER //
// ./src/Wizard/HandleHr.js